import { css } from 'styled-components';
import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/lego';

export const list: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
`;

export const item: ThemedFunctor = ({ theme }) => css`
  border-bottom: 1px solid ${theme.palettes.neutrals.light};

  &:first-of-type {
    border-top: 1px solid ${theme.palettes.neutrals.light};
  }

  &:last-of-type {
    border-bottom: 0;
  }
`;

export const pagination: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  display: flex;
  justify-content: center;
`;
